/**
 * Persist the selected Tenant AWS link id for BeaCon chat / inventory headers.
 */
const STORAGE_KEY = 'beacon-selected-aws-link-id'

export function getSelectedAwsLinkId(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

export function setSelectedAwsLinkId(linkId: string | null): void {
  try {
    if (!linkId) {
      localStorage.removeItem(STORAGE_KEY)
      return
    }
    localStorage.setItem(STORAGE_KEY, linkId)
  } catch {
    /* ignore quota / private mode */
  }
}
